import { Component, OnChanges, Input, Output, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { ConcursosService } from './concursos.service';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { ListConcursosService } from './list.service';
import { saveAs } from 'file-saver';

import { IFRConcursos } from './concursos.interfaces';
import { resumeDataInterface } from '../interfaces/resume';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-concursos',
  templateUrl: 'concursos.component.html',
  styleUrls: ['concursos.component.scss']
})
export class ConcursosComponent implements OnInit {

   private routeParamsSubs: any;

   public showAsyncProgress: boolean = false;
   public concursosData: Array<IFRConcursos> = [];

   public activeFilters = {'estat': 'Tancats & Finalitzats', 'ppropi': null, 'pproj': null, 'ambit': null, 'ciutat':null, 'pais':null, 'any_signatura': null, 'cpv':null, 'certificat': true, 'tematica': null, 'grup_tematiques': null, 'any_ult_factura': null, 'client': null};
   private currentOrdering: any = {};
   private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

   public firstRegisterShown: number = 0;
   public lastRegisterShown: number;
   public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
   private unsubscriber : Subject<void> = new Subject<void>();
   public data: Array<number> = [];

   public showFilters: boolean = true;
   public orderingParameters: any;
   public export: boolean = false;
   public showDialog: boolean = false;
   private ConcursosModel: IFRConcursos = {'offset': null, 'registers': null, 'rows': []};
   public tableFields: Array<any>

   public resumeData: resumeDataInterface = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, totalCON:0, numEU: 0, numE: 0, numInt: 0, numCAT: 0, numCON: 0},
        empresa:{totalMCRIT: 0, totalMULTI: 0,  totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};

   public toggleFiltersVisibility() {
    this.showFilters = !this.showFilters;
   }

   public sendActiveFilters(){
    this.requestRowsToParent();
   }

   public resetActiveFilters() {
    this.activeFilters = {'estat': 'Tancats & Finalitzats', 'ppropi': null, 'pproj': null, 'ambit': null, 'ciutat':null, 'pais': null, 'any_signatura': null, 'cpv':null, 'certificat': true, 'tematica': null, 'grup_tematiques': null, 'any_ult_factura': null, 'client': null};
    this.requestRowsToParent();
   }

   public computeActiveFilters(){
    this.firstRegisterShown = 1 + this.listConcursosService.currentPage * this.listConcursosService.rowsPerPage;
    this.requestRowsToParent();
   }

   private computeDisplayedRows(): void {
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listConcursosService.rowsPerPage - 1, this.concursosData.length);
   }

   public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private requestRowsToParent(): void {
      this.resumeData = {ambit:{totalEU: 0, totalE: 0, totalInt: 0, totalCAT: 0, totalCON: 0, numEU: 0, numE: 0, numInt: 0, numCAT: 0, numCON: 0},
      empresa:{totalMCRIT: 0, totalMULTI: 0,  totalAIEMULTI: 0, totalERSI: 0, totalGEO: 0, numMCRIT: 0, numMULTI: 0, numAIEMULTI: 0, numERSI: 0, numGEO: 0}};
      
      this.concursosService.get(
        this.listConcursosService.rowsPerPage, //Limit
        (this.firstRegisterShown?this.firstRegisterShown:1) - 1, //skip
        this.activeFilters
        ,{}
        ,this.currentOrdering, this.export 
      ).subscribe(
        data => {
          let dades = data["rows"];
          dades.map(item => {
            //if(item["empresa"] != "Consorci")
            switch(item["ambit"]){
              case 'Europa': this.resumeData.ambit.totalEU+=item["pressupost_projecte"];this.resumeData.ambit.numEU++;break;
              case 'Internacional': this.resumeData.ambit.totalInt+=item["pressupost_projecte"];this.resumeData.ambit.numInt++;break;
              case 'Espanya': this.resumeData.ambit.totalE+=item["pressupost_projecte"];this.resumeData.ambit.numE++;break;
              case 'Catalunya': this.resumeData.ambit.totalCAT+=item["pressupost_projecte"];this.resumeData.ambit.numCAT++;break;
              case 'Consorci': this.resumeData.ambit.totalCAT+=item["pressupost_projecte"];this.resumeData.ambit.numCON++;break;
              default: /*console.log("Altres àmbits: "+item);*/
            };
            switch(item["empresa"]){
              case 'MCRIT': this.resumeData.empresa.totalMCRIT+=item["pressupost_projecte"];this.resumeData.empresa.numMCRIT++;break;
              case 'Multicriteri': this.resumeData.empresa.totalMULTI+=item["pressupost_projecte"];this.resumeData.empresa.numMULTI++;break;
              case 'Multicriteri MCRIT AIE': this.resumeData.empresa.totalAIEMULTI+=item["pressupost_projecte"];this.resumeData.empresa.numAIEMULTI++;break;
              case 'Ersília': this.resumeData.empresa.totalERSI+=item["pressupost_projecte"];this.resumeData.empresa.numERSI++;break;
              case 'Geovincles': this.resumeData.empresa.totalGEO+=item["pressupost_projecte"];this.resumeData.empresa.numGEO++;break;
              default: ;
            }
          });
          if(!this.export){this.concursosData = data["rows"];this.computeDisplayedRows();}
          else{this.export = false;
            var csvData = this.convertToCSV(data["rows"]);
            var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
            saveAs(file, "export.csv");
          }
        },
        error => console.log(error)
      );
  }

  public exportar(){this.export = true;this.requestRowsToParent();};

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(JSON.stringify(objArray)) : objArray;

    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public requestPrevious(): void {
     this.listConcursosService.currentPage = Math.max(0, this.listConcursosService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public requestNext(): void {
     this.listConcursosService.currentPage = this.listConcursosService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public setRowPerPage(rowsPerPage: number) {
    this.listConcursosService.rowsPerPage = rowsPerPage;
    this.requestRowsToParent();
  }

  public concursosFilters: Array<any>
  public ordreCamps: Array<any>

  public seleccionaTematiques($event){
    this.activeFilters.tematica = [];
    this.listConcursosService.tematiques_grup.filter(item => item.text == $event).map(item =>{
      this.activeFilters.tematica.push(item.value);
    });
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, private concursosService: ConcursosService, public dialog:MatDialog, public listConcursosService: ListConcursosService, private route: ActivatedRoute) { 
    this.listConcursosService.valFiltres.rows["estat"] = ["Tancats & Finalitzats", "Altres"]; 
    this.listConcursosService.valFiltres.rows["certificat"] = ["Rebut / NA", "Pendent"]; 

    this.listConcursosService.getAutocomplete("any_signaturaProj").subscribe(resul => 
      this.listConcursosService.valFiltres.rows["any_signatura"] = resul, err => console.log(err));

    this.listConcursosService.getAutocomplete("any_ult_facturaProj").subscribe(resul => 
      this.listConcursosService.valFiltres.rows["any_ult_factura"] = resul, err => console.log(err));

    this.listConcursosService.getAutocomplete("ciutatProp").subscribe(resul => 
      this.listConcursosService.valFiltres.rows["ciutat"] = resul, err => console.log(err));

    this.listConcursosService.getAutocomplete("paisProp").subscribe(resul => 
      this.listConcursosService.valFiltres.rows["pais"] = resul, err => console.log(err));

    this.listConcursosService.getAutocomplete("ambitProp").subscribe(resul => 
      this.listConcursosService.valFiltres.rows["ambit"] = resul, err => console.log(err));

    this.listConcursosService.getAutocomplete("tematica").subscribe(resul => 
      this.listConcursosService.valFiltres.rows["tematiques"] = resul, err => console.log(err));
 
    this.listConcursosService.getAutocomplete("grup_tematiques").subscribe(resul => 
      this.listConcursosService.valFiltres.rows["grup_tematiques"] = resul, err => console.log(err));
    //seleccionaTematiques()
    this.listConcursosService.getAutocomplete("tematica_grup").subscribe(resul => 
      this.listConcursosService.tematiques_grup = resul, err => console.log(err));
  }

  ngOnInit() {
     this.tableFields = [
      ['clau', 'Nom'],
      ['empresa', 'Empresa'],
      ['titol', 'Títol'],
      ['pais', 'País'],
      ['ciutat', 'Ciutat'],
      ['client', 'Client'],
      ['data_signatura', 'Data signatura']
    ];

  this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    //La i és una xapussa per ordenar DESC el 1r i ASC el 2n
    ['data_signatura', 'clau'].map((item, i) => this.currentOrdering[item] = this.orderingCycle[2-i]);
    this.computeActiveFilters();

     history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });
  }


  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
